<template>
    <div class="is-size-3 columns has-text-centered">
        <div class="column is-6">
            <span class="icon">
                <i class="fas fa-medal"></i>
            </span>
        </div>
        <div class="column is-6">{{ value }}</div>
    </div>
</template>

<script setup lang="ts">
    defineProps<{ value: number }>();
</script>

<style scoped></style>
